module.exports = __webpack_public_path__ + "static/media/Thanh2.f8bb608c.png";